var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.deck.thumbnail && _vm.deck.thumbnail.url)?_c('v-img',{attrs:{"src":_vm.deck.thumbnail.url,"max-width":"100%","contain":"","alt":"Thumbnail"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }